<script setup lang="ts">
type Props = {
  href: string;
  image: string;
  title: string;
  width?: number;
  height?: number;
  rounded?: boolean;
};

const {
  href,
  image,
  title,
  width = 60,
  height = 60,
  rounded = false,
} = defineProps<Props>();

const widthWithPx = computed(() => {
  return `${width || 60}px`;
});

const heightWithPx = computed(() => {
  return `${height || 60}px`;
});
</script>

<template>
  <div :class="$style.patronageWrap">
    <a
      v-if="href"
      :class="[$style.patronageItem, { [$style.roundedItem]: rounded }]"
      :href="href"
      rel="noopener"
      target="_blank"
    >
      <img
        :alt="title"
        :class="$style.patronageImg"
        :height="heightWithPx"
        :src="image"
        :width="widthWithPx"
      />
    </a>
    <span
      v-else
      :class="[$style.patronageItem, { [$style.roundedItem]: rounded }]"
    >
      <img
        :alt="title"
        :class="$style.patronageImg"
        :height="heightWithPx"
        :src="image"
        :width="widthWithPx"
      />
    </span>
    <p :class="$style.title">
      {{ title }}
    </p>
  </div>
</template>

<style module lang="postcss">
.patronageWrap {
  @apply w-full;

  width: v-bind(widthWithPx);
  min-width: v-bind(widthWithPx);
  max-width: v-bind(widthWithPx);
  min-height: v-bind(heightWithPx);
}

.patronageItem {
  @apply flex flex-col items-center p-1.5 w-full justify-center;

  width: v-bind(widthWithPx);
  height: v-bind(heightWithPx);
  min-width: v-bind(widthWithPx);
  min-height: v-bind(heightWithPx);
  max-width: v-bind(widthWithPx);
  max-height: v-bind(heightWithPx);

  &.roundedItem {
    @apply p-2 bg-texts/10 m-1 rounded-full;
  }

  .patronageImg {
    @apply w-full h-full object-contain;
  }
}
.title {
  @apply text-texts/80 text-[.62rem] text-center place-self-auto;
}
</style>
